import React from "react";
import "./index.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { StyledEngineProvider } from "@mui/material/styles";
import App from "./App";
import { createRoot } from "react-dom/client";

const ReactQueryConfig = {
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
};

const container = document.getElementById("root");
const root = createRoot(container);

const queryClient = new QueryClient(ReactQueryConfig);

root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <StyledEngineProvider injectFirst>
        <App />
      </StyledEngineProvider>
    </QueryClientProvider>
  </BrowserRouter>,
  // </React.StrictMode>,
);
